import { formatEndpoint } from '@omnipresentgroup/helpers';
import type { GetSalaryHistoryAPIResponse } from '@omnipresentgroup/types';
import { HttpResponse, http } from 'msw';

import { API_PATH } from './constants';
import { DEFAULT_GET_SALARY_HISTORY_RESPONSE } from './fixtures';

export const salaryHistoryHandlers = [
  http.get<{ companyId: string }, GetSalaryHistoryAPIResponse>(
    formatEndpoint(`${API_PATH}/company/:companyId`),
    () => HttpResponse.json(DEFAULT_GET_SALARY_HISTORY_RESPONSE),
  ),
];
